import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form } from "react-bootstrap";
import { LINKS } from "shared/config";
import { useTranslation } from "react-i18next";
import Icons from "shared/icons";

function PlaceOfBirth({ value, onChange, ...props }) {
  const { t } = useTranslation("A1");
  return (
    <>
      <Form.Group controlId="city-of-birth">
        <Form.Label>{t("labels.city_of_birth")}</Form.Label>
        <Form.Control
          as="textarea"
          name="birth_of_place"
          maxLength={58}
          value={value}
          onChange={onChange}
          rows={3}
          {...props}
        />
        <Form.Control.Feedback type="invalid">
          {t("validations.place_of_birth.is_required")}
        </Form.Control.Feedback>
        <Form.Text>{t("gdpr_clause_acceptance_text")}</Form.Text>
      </Form.Group>
      <a
        className="d-flex align-items-center fw-bolder my-2 small"
        href={LINKS.gdpr_clause}
        target="_blank"
        rel="noreferrer"
      >
        {t("gdpr_clause")}
        <FontAwesomeIcon
          className="ms-2 anchor-icon"
          icon={Icons.arrowUpRightFromSquare}
        />
      </a>
    </>
  );
}

export default PlaceOfBirth;
